import { Api } from '@/infrastructure';
import { CompanyRecreationPlan } from '@/types';

type UseCompanyRecreationPlanHook = {
  postCompanyRecreationPlan: (
    recreationPlanId: number
  ) => Promise<{ data: CompanyRecreationPlan; redirectUrl: string }>;
};

export const useCompanyRecreationPlan = (): UseCompanyRecreationPlanHook => {
  const postCompanyRecreationPlan = async (
    recreationPlanId: number
  ): Promise<{ data: CompanyRecreationPlan; redirectUrl: string }> => {
    const data = {
      company_recreation_plan: {
        recreation_plan_id: recreationPlanId,
      },
    };

    const response = await Api.post<{
      companyRecreationPlan: CompanyRecreationPlan;
      redirectUrl: string;
    }>(`company_recreation_plans`, 'customer', data);

    return {
      data: response.data.companyRecreationPlan,
      redirectUrl: response.data.redirectUrl,
    };
  };

  return {
    postCompanyRecreationPlan,
  };
};
